import React from "react";

const ContactInfo = () => {
  return (
    <div className="bg-[#EEF2FF] rounded-[32px] py-12 px-6 md:py-16 lg:px-8 max-w-5xl mx-auto mt-16 md:mt-20">
      <div className="text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
          Sorularınız mı var?
        </h2>
        <p className="text-sm md:text-base text-gray-600 mb-6 max-w-2xl mx-auto">
          İhtiyacınız olan her konuda bize ulaşabilirsiniz. Hemen iletişime
          geçin, size en kısa sürede yardımcı olalım!
        </p>
        <button className="bg-[#6366F1] text-white px-6 py-3 rounded-lg hover:bg-[#4F46E5] transition-colors text-sm sm:text-base font-medium">
          Hemen Bizimle İletişime Geçin
        </button>
      </div>
    </div>
  );
};

export default ContactInfo;
